(function() {
  'use strict';

  /*
   * FC Cart Upsell — Checkout button + subtotal update logic
   *
   * Loaded via cart-drawer section when fc_upsell_enable is true.
   * Uses event delegation on document.body so handlers survive
   * cart drawer re-renders (innerHTML replacements by onCartUpdate).
   *
   * Flow:
   * 1. Checkbox unchecked by default
   * 2. When checked → subtotal updates to include upsell price
   * 3. Click [data-fc-upsell-checkout]
   * 4. If upsell widget visible & checked → add variant via /cart/add.js → checkout
   * 5. Otherwise → checkout with current cart contents
   */

  var submitting = false;
  var RBLS_HTML = '<div class="rbls-ring"><div></div><div></div><div></div><div></div></div>';

  function setLoading(btn, loading) {
    if (loading) {
      btn.disabled = true;
      btn.classList.add('revy-button-loading-state');
      btn.style.setProperty('--rbls-size', btn.offsetHeight * 0.8 + 'px');
      if (!btn.querySelector('.rbls-ring')) {
        btn.insertAdjacentHTML('beforeend', RBLS_HTML);
      }
    } else {
      btn.disabled = false;
      btn.classList.remove('revy-button-loading-state');
      var ring = btn.querySelector('.rbls-ring');
      if (ring) ring.remove();
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('btn--loading');
    }
    submitting = loading;
  }

  /* Reset loading state on back/forward navigation (bfcache) */
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      var btn = document.querySelector('[data-fc-upsell-checkout]');
      if (btn) setLoading(btn, false);
    }
  });

  function getUpsellData() {
    var widget = document.querySelector('[data-fc-cart-upsell]');
    if (!widget) return null;
    var checkbox = widget.querySelector('[data-fc-upsell-check]');
    return {
      checked: checkbox ? checkbox.checked : false,
      variantId: widget.dataset.fcUpsellVariantId,
      priceCents: parseInt(widget.dataset.fcUpsellPrice, 10) || 0,
      compareAtPriceCents: parseInt(widget.dataset.fcUpsellCompareAtPrice, 10) || 0,
      cartTotal: parseInt(widget.dataset.fcCartTotal, 10) || 0,
      moneyFormat: widget.dataset.fcMoneyFormat || ''
    };
  }

  /* Update the Subtotaal in drawer__footer-body */
  function updateSubtotal(checked) {
    var upsell = getUpsellData();
    if (!upsell) return;

    var subtotalEl = document.querySelector('.drawer__footer-body .totals__subtotal-value');
    if (!subtotalEl) return;

    var newTotal = checked ? upsell.cartTotal + upsell.priceCents : upsell.cartTotal;
    var moneyFmt = upsell.moneyFormat || FoxTheme.settings.moneyFormat;

    /* Update compare-at subtotal if present */
    var compareAtEl = subtotalEl.querySelector('.fc-subtotal-compare-at');
    var currentEl = subtotalEl.querySelector('.fc-subtotal-current');

    if (compareAtEl && currentEl) {
      var baseCompareAt = parseInt(subtotalEl.dataset.fcCompareAtTotal, 10) || 0;
      var newCompareAt = checked ? baseCompareAt + upsell.compareAtPriceCents : baseCompareAt;

      if (newCompareAt > newTotal) {
        compareAtEl.innerHTML = FoxTheme.Currency.formatMoney(newCompareAt, moneyFmt);
        compareAtEl.style.display = '';
        currentEl.classList.add('fc-subtotal-current--on-sale');
      } else {
        compareAtEl.style.display = 'none';
        currentEl.classList.remove('fc-subtotal-current--on-sale');
      }
      currentEl.innerHTML = FoxTheme.Currency.formatMoney(newTotal, moneyFmt);
    } else {
      subtotalEl.innerHTML = FoxTheme.Currency.formatMoney(newTotal, moneyFmt);
    }
  }

  /* Update free-shipping-goal progress to reflect upsell toggle */
  function updateFreeShippingGoal(checked) {
    var upsell = getUpsellData();
    if (!upsell) return;

    var goals = document.querySelectorAll('free-shipping-goal');
    if (!goals.length) return;

    var adjustedTotal = checked
      ? upsell.cartTotal + upsell.priceCents
      : upsell.cartTotal;

    goals.forEach(function(goal) {
      if (typeof goal.updateShippingGloal === 'function') {
        goal.updateShippingGloal(adjustedTotal);
      }
    });
  }

  /* Listen for checkbox changes via delegation (widget is re-rendered on cart updates) */
  document.body.addEventListener('change', function(e) {
    if (!e.target.matches('[data-fc-upsell-check]')) return;
    updateSubtotal(e.target.checked);
    updateFreeShippingGoal(e.target.checked);
  });

  /* Shopify standard: POST to /cart with checkout param redirects to checkout */
  function triggerNativeCheckout() {
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = (window.Shopify.routes.root || '/') + 'cart';
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'checkout';
    input.value = '';
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  }

  document.body.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-fc-upsell-checkout]');
    if (!btn) return;

    e.preventDefault();
    if (submitting) return;
    setLoading(btn, true);

    var upsell = getUpsellData();

    if (upsell && upsell.checked && upsell.variantId) {
      /* Add upsell to cart, then trigger checkout */
      fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: parseInt(upsell.variantId, 10),
          quantity: 1
        })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function() {
        triggerNativeCheckout();
      })
      .catch(function() {
        /* If add fails, proceed to checkout with existing cart */
        triggerNativeCheckout();
      });
    } else {
      /* No upsell or unchecked — checkout with current cart */
      triggerNativeCheckout();
    }
  });
})();
